import {
    CalendarClock, Sprout, Leaf, LeafyGreen, Flower, Cherry, Wheat, Scissors, Circle,
} from "lucide-react";

// Map each crop stage to a distinctive Lucide icon + earthy colour.
// The icons render on the bed grid (BedGridEditor cells) and anywhere we
// show stage alongside a crop name.
export const STAGE_META = {
    planned:    { icon: CalendarClock, label: "Planned",    color: "var(--vm-text-muted)" },
    sown:       { icon: Circle,        label: "Sown",       color: "#8B6F47" }, // soil brown
    germinated: { icon: Sprout,        label: "Germinated", color: "#7FB069" }, // fresh sprout
    seedling:   { icon: Leaf,          label: "Seedling",   color: "#6B8C5C" }, // sage
    vegetative: { icon: LeafyGreen,    label: "Vegetative", color: "#5A7A3C" }, // dark green
    flowering:  { icon: Flower,        label: "Flowering",  color: "#D4A04C" }, // golden
    fruiting:   { icon: Cherry,        label: "Fruiting",   color: "#C06547" }, // terracotta
    harvest:    { icon: Wheat,         label: "Harvest",    color: "#B8421F" }, // deep terracotta
    finished:   { icon: Scissors,      label: "Finished",   color: "var(--vm-text-muted)" },
};

export function StageIcon({ stage, size = 16, className = "", strokeWidth = 1.75 }) {
    const meta = STAGE_META[stage] || STAGE_META.planned;
    const Icon = meta.icon;
    return (
        <Icon
            size={size}
            strokeWidth={strokeWidth}
            className={className}
            style={{ color: meta.color }}
            data-stage={stage}
            data-testid={`stage-icon-${stage}`}
        />
    );
}

export function stageColor(stage) {
    return (STAGE_META[stage] || STAGE_META.planned).color;
}

export function stageLabel(stage) {
    return (STAGE_META[stage] || STAGE_META.planned).label;
}
